import PropTypes from 'prop-types'
import { Button } from '@context365/button'
import { Input } from '@context365/forms'
import { RemoveCircleOutline } from '@context365/icons'
import FileField from './FileField'

const ClientField = ({
  value,
  onChange,
  showAdd,
  addItem,
  showRemove,
  removeItem,
  errors,
  listNumber,
}) => {
  const handleChange = (field, val) => {
    onChange({ ...value, [field]: val })
  }
  return (
    <>
      <div className="mb-8">
        <div className="flex justify-between">
          <div className="type-body-semibold-md">Client #{listNumber}</div>
          {showRemove && (
            <div className="hidden md:flex">
              <Button
                variant="outlined"
                status="error"
                iconLeft={<RemoveCircleOutline />}
                onClick={() => removeItem()}
              >
                Remove Client
              </Button>
            </div>
          )}
        </div>
        <div className="md:grid md:grid-cols-4 md:gap-4 mb-2">
          <div>
            <Input
              errorMessage={errors?.name}
              required
              label="Name"
              name="name"
              value={value.name}
              onChange={(e) => handleChange('name', e.target.value)}
            />
          </div>
        </div>
        <div>
          <FileField
            hint={[
              'Drag or click here to upload a logo',
              'File Types: .JPG, .PNG',
              'Max File Size: 4MB',
            ]}
            accept=".jpg, .png"
            value={value.logoUrl}
            onChange={(e) => handleChange('logoUrl', e.target.value)}
            listLength={1}
            listType="picture"
          />
        </div>
      </div>
      {showRemove && (
        <div className="md:hidden mb-8">
          <Button
            className="w-full"
            iconLeft={<RemoveCircleOutline />}
            variant="outlined"
            status="error"
            onClick={() => removeItem()}
          >
            Remove Client
          </Button>
        </div>
      )}
      {showAdd && (
        <div>
          <Button variant="link" onClick={() => addItem()}>
            + Add Client
          </Button>
        </div>
      )}
    </>
  )
}

ClientField.propTypes = {
  value: PropTypes.object,
  errors: PropTypes.object,
  onChange: PropTypes.func,
  showAdd: PropTypes.bool,
  showRemove: PropTypes.bool,
  addItem: PropTypes.func,
  removeItem: PropTypes.func,
  listNumber: PropTypes.number,
}
export default ClientField
